import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPets = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "inherit",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8.33234 4.3103C8.33234 3.15196 7.01817 2.2328 5.41567 2.5003C3.06317 2.89196 1.98817 7.5053 2.08234 8.33363C2.14901 8.91946 3.51984 9.76863 5.12901 9.16696C6.17984 8.77363 6.76234 7.95863 7.08234 7.08363M11.8882 4.3103C11.8882 3.15196 13.2023 2.2328 14.8048 2.5003C17.1573 2.89196 18.2323 7.5053 18.1382 8.33363C18.0715 8.91946 16.7007 9.76863 15.0915 9.16696C14.0407 8.77363 13.5457 7.95863 13.2257 7.08363M6.66567 11.667V12.0836M13.3323 11.667V12.0836M9.37401 13.542H10.624L9.99901 14.167L9.37401 13.542Z"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "inherit",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.68301 9.37257C3.44979 10.2732 3.33218 11.1998 3.33301 12.1301C3.33301 15.6067 6.31801 17.5001 9.99968 17.5001C13.6813 17.5001 16.6663 15.6067 16.6663 12.1301C16.6663 11.2459 16.5313 10.2967 16.2555 9.37257M8.55301 4.30424C9.02949 4.21063 9.51409 4.16457 9.99968 4.16674C10.6497 4.16674 11.2497 4.25674 11.8005 4.42174"
	})]
});
export default SvgPets;
